"use strict";

var _clientAuth = require("@devsta/client-auth");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = _default;

function _default(_ref) {
  var userId = _ref.userId,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      imageUrl = _ref.imageUrl,
      name = "".concat(firstName, " ").concat(lastName),
      currentCredentials = _clientAuth.credentials.get(),
      currentUserId = currentCredentials.user.userId;

  return {
    userId: userId,
    name: name,
    imageUrl: imageUrl,
    isUser: currentUserId === userId
  };
}